import { render, staticRenderFns } from "./PointsTask.vue?vue&type=template&id=1bf4478b&scoped=true&"
import script from "./PointsTask.vue?vue&type=script&lang=js&"
export * from "./PointsTask.vue?vue&type=script&lang=js&"
import style0 from "./PointsTask.vue?vue&type=style&index=0&id=1bf4478b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf4478b",
  null
  
)

export default component.exports